// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file system/v1/events.proto (package system.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_events } from "../../common/v1/events_pb";
import type { Duration, DurationJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file system/v1/events.proto.
 */
export const file_system_v1_events: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChZzeXN0ZW0vdjEvZXZlbnRzLnByb3RvEglzeXN0ZW0udjEi3AEKDVB1cmdlVXNlckRhdGESDwoHdXNlcl9pZBgBIAEoCRIRCgVlbWFpbBgCIAEoCUICGAESEgoKcHJpbWFyeV9pZBgEIAEoCRIOCgZvcmdfaWQYBSABKAkSLgoGd2luZG93GAMgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uSACIAQESEwoGam9iX2lkGAYgASgJSAGIAQESFQoIcHVyZ2VfaWQYByABKAlIAogBAToEiLUYAUIJCgdfd2luZG93QgkKB19qb2JfaWRCCwoJX3B1cmdlX2lkIqwBChVQdXJnZU9yZ2FuaXphdGlvbkRhdGESDgoGb3JnX2lkGAEgASgJEi4KBndpbmRvdxgCIAEoCzIZLmdvb2dsZS5wcm90b2J1Zi5EdXJhdGlvbkgAiAEBEhMKBmpvYl9pZBgDIAEoCUgBiAEBEhUKCHB1cmdlX2lkGAQgASgJSAKIAQE6BIi1GAFCCQoHX3dpbmRvd0IJCgdfam9iX2lkQgsKCV9wdXJnZV9pZCKqAQoOUHVyZ2VDb21wbGV0ZWQSEwoGam9iX2lkGAEgASgJSACIAQESFQoIcHVyZ2VfaWQYAiABKAlIAYgBARIWCglzb3VyY2VfaWQYBCABKAlIAogBARIoCghtZXRhZGF0YRgDIAEoCzIWLmdvb2dsZS5wcm90b2J1Zi5WYWx1ZToEiLUYAUIJCgdfam9iX2lkQgsKCV9wdXJnZV9pZEIMCgpfc291cmNlX2lkYgZwcm90bzM",
		[file_common_v1_events, file_google_protobuf_duration, file_google_protobuf_struct],
	);

/**
 * @generated from message system.v1.PurgeUserData
 */
export type PurgeUserData = Message<"system.v1.PurgeUserData"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string email = 2 [deprecated = true];
	 * @deprecated
	 */
	email: string;

	/**
	 * @generated from field: string primary_id = 4;
	 */
	primaryId: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * @generated from field: optional google.protobuf.Duration window = 3;
	 */
	window?: Duration | undefined;

	/**
	 * @generated from field: optional string job_id = 6;
	 */
	jobId?: string | undefined;

	/**
	 * @generated from field: optional string purge_id = 7;
	 */
	purgeId?: string | undefined;
};

/**
 * @generated from message system.v1.PurgeUserData
 */
export type PurgeUserDataJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string email = 2 [deprecated = true];
	 * @deprecated
	 */
	email?: string;

	/**
	 * @generated from field: string primary_id = 4;
	 */
	primaryId?: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional google.protobuf.Duration window = 3;
	 */
	window?: DurationJson;

	/**
	 * @generated from field: optional string job_id = 6;
	 */
	jobId?: string;

	/**
	 * @generated from field: optional string purge_id = 7;
	 */
	purgeId?: string;
};

/**
 * Describes the message system.v1.PurgeUserData.
 * Use `create(PurgeUserDataSchema)` to create a new message.
 */
export const PurgeUserDataSchema: GenMessage<PurgeUserData, { jsonType: PurgeUserDataJson }> = /*@__PURE__*/ messageDesc(file_system_v1_events, 0);

/**
 * @generated from message system.v1.PurgeOrganizationData
 */
export type PurgeOrganizationData = Message<"system.v1.PurgeOrganizationData"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: optional google.protobuf.Duration window = 2;
	 */
	window?: Duration | undefined;

	/**
	 * @generated from field: optional string job_id = 3;
	 */
	jobId?: string | undefined;

	/**
	 * @generated from field: optional string purge_id = 4;
	 */
	purgeId?: string | undefined;
};

/**
 * @generated from message system.v1.PurgeOrganizationData
 */
export type PurgeOrganizationDataJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional google.protobuf.Duration window = 2;
	 */
	window?: DurationJson;

	/**
	 * @generated from field: optional string job_id = 3;
	 */
	jobId?: string;

	/**
	 * @generated from field: optional string purge_id = 4;
	 */
	purgeId?: string;
};

/**
 * Describes the message system.v1.PurgeOrganizationData.
 * Use `create(PurgeOrganizationDataSchema)` to create a new message.
 */
export const PurgeOrganizationDataSchema: GenMessage<PurgeOrganizationData, { jsonType: PurgeOrganizationDataJson }> = /*@__PURE__*/ messageDesc(file_system_v1_events, 1);

/**
 * @generated from message system.v1.PurgeCompleted
 */
export type PurgeCompleted = Message<"system.v1.PurgeCompleted"> & {
	/**
	 * @generated from field: optional string job_id = 1;
	 */
	jobId?: string | undefined;

	/**
	 * @generated from field: optional string purge_id = 2;
	 */
	purgeId?: string | undefined;

	/**
	 * @generated from field: optional string source_id = 4;
	 */
	sourceId?: string | undefined;

	/**
	 * @generated from field: google.protobuf.Value metadata = 3;
	 */
	metadata?: Value | undefined;
};

/**
 * @generated from message system.v1.PurgeCompleted
 */
export type PurgeCompletedJson = {
	/**
	 * @generated from field: optional string job_id = 1;
	 */
	jobId?: string;

	/**
	 * @generated from field: optional string purge_id = 2;
	 */
	purgeId?: string;

	/**
	 * @generated from field: optional string source_id = 4;
	 */
	sourceId?: string;

	/**
	 * @generated from field: google.protobuf.Value metadata = 3;
	 */
	metadata?: ValueJson;
};

/**
 * Describes the message system.v1.PurgeCompleted.
 * Use `create(PurgeCompletedSchema)` to create a new message.
 */
export const PurgeCompletedSchema: GenMessage<PurgeCompleted, { jsonType: PurgeCompletedJson }> = /*@__PURE__*/ messageDesc(file_system_v1_events, 2);
